import React, { lazy, Suspense } from 'react';
import { Navigate, createBrowserRouter } from 'react-router-dom';

import App from 'App';

// Layouts
import MainLayout from 'layouts/MainLayout';
import AuthSimpleLayout from 'layouts/AuthSimpleLayout';

// Auth pages
import Login from 'pages/auth/Login';
import PrivateRoute from 'pages/auth/PrivateRoute';

// WMS pages (lazy loaded)
const Dashboard = lazy(() => import('pages/Dashboard'));
const LocationsList = lazy(() => import('pages/locations/LocationsList'));
const LocationsForm = lazy(() => import('pages/locations/LocationsForm'));
const ProductsList = lazy(() => import('pages/products/ProductsList'));
const ProductsForm = lazy(() => import('pages/products/ProductsForm'));
const LpnsList = lazy(() => import('pages/lpns/LpnsList'));
const DocumentsList = lazy(() => import('pages/documents/DocumentsList'));
const DocumentsForm = lazy(() => import('pages/documents/DocumentsForm'));
const DocumentDetailPage = lazy(() => import('pages/documents/DocumentDetailPage'));
const UsersList = lazy(() => import('pages/users/UsersList'));
const UsersForm = lazy(() => import('pages/users/UsersForm'));

const Loading = () => (
    <div className="d-flex justify-content-center align-items-center min-vh-100">
        <div className="spinner-border text-primary" role="status" />
    </div>
);

const routes = createBrowserRouter([
    {
        element: <App />,
        children: [
            {
                element: <AuthSimpleLayout />,
                children: [{ path: '/auth/login', element: <Login /> }]
            },
            {
                element: (
                    <PrivateRoute>
                        <MainLayout />
                    </PrivateRoute>
                ),
                children: [
                    { path: '/', element: <Navigate to="/dashboard" replace /> },
                    {
                        path: '/dashboard',
                        element: (
                            <Suspense fallback={<Loading />}>
                                <Dashboard />
                            </Suspense>
                        )
                    },
                    {
                        path: '/locations',
                        element: (
                            <Suspense fallback={<Loading />}>
                                <LocationsList />
                            </Suspense>
                        )
                    },
                    {
                        path: '/locations/new',
                        element: (
                            <Suspense fallback={<Loading />}>
                                <LocationsForm />
                            </Suspense>
                        )
                    },
                    {
                        path: '/locations/edit/:id',
                        element: (
                            <Suspense fallback={<Loading />}>
                                <LocationsForm />
                            </Suspense>
                        )
                    },
                    {
                        path: '/products',
                        element: (
                            <Suspense fallback={<Loading />}>
                                <ProductsList />
                            </Suspense>
                        )
                    },
                    {
                        path: '/products/new',
                        element: (
                            <Suspense fallback={<Loading />}>
                                <ProductsForm />
                            </Suspense>
                        )
                    },
                    {
                        path: '/products/edit/:id',
                        element: (
                            <Suspense fallback={<Loading />}>
                                <ProductsForm />
                            </Suspense>
                        )
                    },
                    {
                        path: '/lpns',
                        element: (
                            <Suspense fallback={<Loading />}>
                                <LpnsList />
                            </Suspense>
                        )
                    },
                    {
                        path: '/documents',
                        element: (
                            <Suspense fallback={<Loading />}>
                                <DocumentsList />
                            </Suspense>
                        )
                    },
                    {
                        path: '/documents/new',
                        element: (
                            <Suspense fallback={<Loading />}>
                                <DocumentsForm />
                            </Suspense>
                        )
                    },
                    {
                        path: '/documents/:id',
                        element: (
                            <Suspense fallback={<Loading />}>
                                <DocumentDetailPage />
                            </Suspense>
                        )
                    },
                    {
                        path: '/users',
                        element: (
                            <Suspense fallback={<Loading />}>
                                <UsersList />
                            </Suspense>
                        )
                    },
                    {
                        path: '/users/new',
                        element: (
                            <Suspense fallback={<Loading />}>
                                <UsersForm />
                            </Suspense>
                        )
                    },
                    {
                        path: '/users/view/:id',
                        element: (
                            <Suspense fallback={<Loading />}>
                                <UsersForm />
                            </Suspense>
                        )
                    }
                ]
            },
            {
                path: '*',
                element: <Navigate to="/dashboard" replace />
            }
        ]
    }
]);

export { routes as router };
